de:
  title: Meldung
fr:
  title: Message
it:
  title: Notifica
